import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import ArtifactViewMainContentFixInfoRangeOverview from '~/artifact/containers/ArtifactViewMainContentFixInfoRangeOverview';
import ArtifactViewMainContentFixInfoSafeVersions from '~/artifact/containers/ArtifactViewMainContentFixInfoSafeVersions';
import ArtifactViewMainContentFixInfoHowToFix from '~/artifact/containers/ArtifactViewMainContentFixInfoHowToFix';
import TabWrapper from '~/components/TabWrapper';
import TabItem from '~/components/TabItem';
import AutosuggestFilter from '~/containers/AutosuggestFilter';
import Helpers from '~/utils/Helpers';
import LoaderWrapper from '~/components/LoaderWrapper';
import * as actions from '~/artifact/actions';
import { vulnerabilityRangeTypesMap } from '~/constants/ModelConstants';
type ArtifactViewMainContentFixInfoProps = {
  artifact: object;
  artifactState: object;
  actions: object;
};
class ArtifactViewMainContentFixInfo extends React.Component<
  ArtifactViewMainContentFixInfoProps,
  {}
> {
  constructor(props, context) {
    super(props, context);
    this.delayedHandleCommitHashChange = _.debounce(this.handleCommitHashChange, 300);
  }
  componentDidMount() {
    this.props.actions.updateActiveVulnRangeTab(vulnerabilityRangeTypesMap.VERSIONS);
  }
  componentWillUnmount() {
    this.props.actions.updateActiveVulnRangeTab(vulnerabilityRangeTypesMap);
    this.props.actions.updateArtifactActiveCommitHash('');
    this.props.actions.updateActiveSafeCommitHash('');
  }
  handleTabClick = field => {
    this.props.actions.updateActiveVulnRangeTab(field);
    this.props.actions.updateActiveSafeCommitHash('');
  };
  handleCommitHashChange(commitHash) {
    if (!commitHash || !Helpers.isCommitHash(commitHash)) {
      this.props.actions.updateArtifactActiveCommitHash('');
      return;
    }
    const { artifactState = {} } = this.props;
    const { componentId } = artifactState;
    this.props.actions.updateArtifactActiveCommitHash(commitHash);
    this.props.actions.maybeFetchCommitHashFixInfo(componentId, commitHash);
  }
  render() {
    const { artifact = {}, artifactState = {} } = this.props;
    const {
      activeVulnRangeTab,
      componentId,
      affectedComponents,
      isFetchingSafeVersionsAfterRange,
      isFetching,
    } = artifactState;
    const component = affectedComponents.find(comp => comp.id === componentId) || {};
    const { languageType } = component;
    const fixInfoHowToFixHtml = (
      <LoaderWrapper
        isLoaderShowing={isFetchingSafeVersionsAfterRange || isFetching}
        loaderType="SPINNER"
        className="min-height--300"
        loaderClassName="text--center p"
        size={'font--30'}
      >
        <ArtifactViewMainContentFixInfoHowToFix />
      </LoaderWrapper>
    );
    return (
      <div className="grid grid--full ph">
        <div className="col-1-1">
          <TabWrapper>
            <div className="grid__item col-1-1 pb-">
              <div className="col-1-1">
                <div className="font--h7 pb">Vulnerable range</div>
              </div>
              {Helpers.isCommitHashSupportedByLanguage(languageType) && (
                <div className="col-1-1 mb bo-b--1 border-color--muted">
                  <TabItem
                    label="Versions"
                    onClick={this.handleTabClick}
                    isActive={activeVulnRangeTab === vulnerabilityRangeTypesMap.VERSIONS}
                    field={vulnerabilityRangeTypesMap.VERSIONS}
                  />
                  <TabItem
                    label="Commit Hashes"
                    onClick={this.handleTabClick}
                    isActive={activeVulnRangeTab === vulnerabilityRangeTypesMap.COMMIT_HASHES}
                    field={vulnerabilityRangeTypesMap.COMMIT_HASHES}
                  />
                </div>
              )}
              {activeVulnRangeTab === vulnerabilityRangeTypesMap.VERSIONS && (
                <div>
                  <ArtifactViewMainContentFixInfoRangeOverview artifact={artifact} />
                  <div className="grid__item col-1-1 pt">
                    <div className="grid">
                      <div
                        className={`grid__item col-1-4 phone--col-1-1 ${
                          isFetchingSafeVersionsAfterRange ? 'invisible' : ''
                        }`}
                      >
                        <ArtifactViewMainContentFixInfoSafeVersions />
                      </div>
                      <div
                        className={`grid__item col-3-4 ${
                          isFetchingSafeVersionsAfterRange ? '' : 'bo-l--1'
                        } border-color--muted phone--col-1-1 phone--bo-0`}
                      >
                        {fixInfoHowToFixHtml}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeVulnRangeTab === vulnerabilityRangeTypesMap.COMMIT_HASHES && (
                <div>
                  <ArtifactViewMainContentFixInfoRangeOverview
                    artifact={artifact}
                    rangeType={vulnerabilityRangeTypesMap.COMMIT_HASHES}
                  />
                  <div className="grid pt flex flex--align-items--center">
                    <div className="grid__item col-1-8 font--h7">Commit Hash:</div>
                    <div className="grid__item col-1-2">
                      <AutosuggestFilter
                        id={`commit-hash-filter`}
                        onChange={commitHash => this.delayedHandleCommitHashChange(commitHash)}
                        options={[]}
                        initialValue={''}
                        placeholder={'Enter commit hash'}
                      />
                    </div>
                  </div>
                  <div className="pt">{fixInfoHowToFixHtml}</div>
                </div>
              )}
            </div>
          </TabWrapper>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentFixInfo);
